export default {"src":"/_next/static/media/error.aed01ef1.svg","height":1080,"width":1080,"blurWidth":0,"blurHeight":0};